export enum UploadType {
    /** 0 */
    UNKNOWN_UPLOAD_TYPE = 'UNKNOWN_UPLOAD_TYPE',
    /** 1 */
    INVOICE = 'INVOICE',
    /** 2 */
    SUPPLIER = 'SUPPLIER',
    /** 3 [deprecated */
    PAYMENT = 'PAYMENT',
    /** 4 */
    PAYMENT_VERIFICATION = 'PAYMENT_VERIFICATION',
    /** 5 */
    ROUTING_INSTRUCTION = 'ROUTING_INSTRUCTION',
    /** 6 */
    REMITTANCE_INSTRUCTION = 'REMITTANCE_INSTRUCTION'
}
